import { render } from "./bottomLineProjectShow.vue?vue&type=template&id=bcb2a420"
import script from "./bottomLineProjectShow.vue?vue&type=script&lang=js"
export * from "./bottomLineProjectShow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__